export default __webpack_public_path__ + "static/media/forfeit.8579c813.mp4";